// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"82c97ed0","645":"e29b3146"}[chunkId] + ".chunk.js";
};